export const translations = {
  en: {
    navbar: {
      title: "SM Design Studio Pvt Ltd"
    },
    banner: {
      status: "Open to a Work",
      heading: "Structures that Inspire",
      description: "We shape spaces the way you imagine life.",
      button: "Enquiry us"
    },
    brand: {
      line1: "WE DESIGN",
      line2: "SPACES",
      line3: "PEOPLE LOVE"
    },
    stats: {
      clients: "Clients Served",
      projects: "Successful Projects",
      awards: "Prestigous Award",
      experience: "Years of Experience"
    },
    services: {
      title: "Our services",
      heading: "Why Choose Us.",
      description: "We make even the wildest architectural dreams into dramatic yet feasible finished products anyone would be proud of.",
      items: [
        "Architectural Design",
        "Interior Design", 
        "Site Supervision & Project Management",
        "Landscaping Design",
        "Building Renovation",
        "Lighting Design",
        "Feasibility Studies",
        "Building Code",
        "3D Visualization"
      ]
    },
    philosophy: {
      heading: "Our Philosophy",
      description1: "At SM Design Studio Pvt Ltd, we view every project as a dialogue between vision and reality. Our design philosophy is rooted in innovation, sustainability, and collaboration—creating architecture that not only defines skylines but also enriches lives. We aim to exceed expectations by delivering personalized, purposeful, and enduring design solutions that stand the test of time.",
      description2: "We don't just design buildings we create experiences that leave a lasting impact"
    },
    projects: {
      title: "Our Project",
      heading: "The Proof is in Our Portfolio",
      description: "Browse a sampling of our favorite built incarnations of clients' imaginative expectations and our innovative solutions."
    },
    journey: {
      title: "Our Founder",
      heading: "A Journey of Design, Growth and Innovation",
      description: "Karan Sethi begins his journey by importing furniture in 2004 to becoming a full-fledged interior design studio, our journey reflects continuous evolution. With roots in retail, we transitioned into interior design in 2011, opened our first design office in 2015, and fully dedicated ourselves to interiors by 2016. As our vision grew, so did our team — expanding in 2022 and moving into a large, modern office in 2025. Every milestone represents our commitment to transforming spaces with creativity, functionality, and innovation."
    },
    quote: {
      text: " We don’t just construct spaces, we curate experiences shaped around your vision."
    },
    team: {
      title: "Our Team",
      heading: "The Skill & Soul Behind Our Projects",
      description: "Our multidisciplinary team of architects, engineers, interior designers, and real estate professionals shares a unified goal—to achieve excellence in every project we undertake. Together, we combine creativity, technical skill, and forward-thinking strategy to transform client visions into architectural landmarks."
    },
    marquee: {
      text: "Vastu & Design Consultation • Turnkey Project Solutions • Landscape & Exterior Design • Renovation & Extension Projects "
    },
    footer: {
      title: "SM Design Studio Pvt Ltd",
      description: "Structures that Inspire",
      phone: "Phone: +91 88513 03071",
      email: "Mail: smdesignstudio84@gmail.com",
      address: "Address: DM-19, Sector-130, Noida",
      button: "Get in touch",
      mainPages: "Main Pages",
      socialLinks: "Social Links",
      pages: {
        home: "Home",
        about: "About",
        service: "Service",
        work: "Our work"
      },
      social: {
        instagram: "Instagram",
        facebook: "Facebook",
        linkedin: "LinkedIn",
        twitter: "Twitter"
      },
      copyright: "©2025 sm.designstudio.pvt.ltd"
    }
  },
  hi: {
    navbar: {
      title: "एसएम डिजाइन स्टूडियो प्राइवेट लिमिटेड"
    },
    banner: {
      status: "काम के लिए खुला",
      heading: "प्रेरणा देने वाली संरचनाएं",
      description: "हम आपके जीवन की कल्पना के अनुरूप स्थानों को आकार देते हैं।",
      button: "हमसे पूछताछ करें"
    },
    brand: {
      line1: "हम डिज़ाइन करते हैं",
      line2: "स्थान",
      line3: "जिन्हें लोग पसंद करते हैं"
    },
    stats: {
      clients: "ग्राहक सेवित",
      projects: "सफल परियोजनाएं",
      awards: "प्रतिष्ठित पुरस्कार",
      experience: "वर्षों का अनुभव"
    },
    services: {
      title: "हमारी सेवाएं",
      heading: "हमें क्यों चुनें",
      description: "हम सबसे जंगली वास्तुकला सपनों को भी नाटकीय लेकिन व्यवहार्य तैयार उत्पादों में बदल देते हैं जिस पर कोई भी गर्व करेगा।",
      items: [
        "वास्तुकला डिज़ाइन",
        "इंटीरियर डिज़ाइन",
        "साइट पर्यवेक्षण एवं परियोजना प्रबंधन",
        "भूदृश्य डिज़ाइन",
        "भवन नवीनीकरण",
        "प्रकाश डिज़ाइन",
        "व्यवहार्यता अध्ययन",
        "भवन कोड",
        "3डी विज़ुअलाइज़ेशन"
      ]
    },
    philosophy: {
      heading: "हमारा दर्शन",
      description1: "एसएम डिज़ाइन स्टूडियो प्राइवेट लिमिटेड में, हम हर परियोजना को कल्पना और वास्तविकता के बीच संवाद के रूप में देखते हैं। हमारी डिज़ाइन फिलॉसफी नवाचार, स्थिरता और सहयोग पर आधारित है—ऐसी वास्तुकला का निर्माण करना जो न केवल शहरों की पहचान बने बल्कि जीवन को भी समृद्ध करे। हमारा लक्ष्य समय की कसौटी पर खरे उतरने वाले व्यक्तिगत, उद्देश्यपूर्ण और टिकाऊ डिज़ाइन समाधान प्रदान करके अपेक्षाओं से कहीं अधिक बेहतर प्रदर्शन करना है।",
      description2: "हम केवल इमारतें नहीं बनाते हैं बल्कि ऐसे अनुभव बनाते हैं जो स्थायी प्रभाव छोड़ते हैं"
    },
    projects: {
      title: "हमारी परियोजना",
      heading: "प्रमाण हमारे पोर्टफोलियो में है",
      description: "ग्राहकों की कल्पनाशील अपेक्षाओं और हमारे नवाचार समाधानों के हमारे पसंदीदा निर्मित अवतारों का नमूना देखें।"
    },
    journey: {
      title: "हमारे संस्थापक",
      heading: "डिज़ाइन, विकास और नवाचार की यात्रा",
      description: "करण सेठी 2004 में फर्नीचर आयात करके अपनी यात्रा शुरू करते हैं और एक पूर्ण इंटीरियर डिज़ाइन स्टूडियो बनने तक, हमारी यात्रा निरंतर विकास को दर्शाती है।"
    },
    quote: {
      text: "हम केवल स्थान नहीं बनाते, हम आपके दृष्टिकोण के अनुरूप अनुभव तैयार करते हैं।"
    },
    team: {
      title: "हमारी टीम",
      heading: "हमारी परियोजनाओं के पीछे कौशल और आत्मा",
      description: "वास्तुकारों, इंजीनियरों, इंटीरियर डिजाइनरों और रियल एस्टेट पेशेवरों की हमारी बहु-विषयक टीम का एक ही लक्ष्य है - हमारे द्वारा शुरू की गई प्रत्येक परियोजना में उत्कृष्टता प्राप्त करना। हम मिलकर रचनात्मकता, तकनीकी कौशल और दूरदर्शी रणनीति का संयोजन करते हैं ताकि ग्राहकों की कल्पनाओं को वास्तुशिल्पीय मील के पत्थर में परिवर्तित कर सकें।"
    },
    marquee: {
      text: "वास्तु एवं डिजाइन परामर्श • टर्नकी परियोजना समाधान • भूदृश्य और बाहरी डिजाइन • नवीनीकरण और विस्तार परियोजनाएं "
    },
    footer: {
      title: "एसएम डिजाइन स्टूडियो प्राइवेट लिमिटेड",
      description: "प्रेरणा देने वाली संरचनाएं",
      phone: "फोन: +91 88513 03071",
      email: "मेल: smdesignstudio84@gmail.com",
      address: "पता: डीएम-19, सेक्टर-130, नोएडा",
      button: "संपर्क करें",
      mainPages: "मुख्य पृष्ठ",
      socialLinks: "सामाजिक लिंक",
      pages: {
        home: "होम",
        about: "के बारे में",
        service: "सेवा",
        work: "हमारा काम"
      },
      social: {
        instagram: "इंस्टाग्राम",
        facebook: "फेसबुक",
        linkedin: "लिंक्डइन",
        twitter: "ट्विटर"
      },
      copyright: "©2025 sm.designstudio.pvt.ltd "
    }
  }
};